// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2V5Az","consentsList":"PatientConsents_consentsList__3Lt-o","consentsListEmpty":"PatientConsents_consentsListEmpty__11g5g"};